import {
  QueryKeys,
  assertParameterIsNotUndefinedOrNull,
  gamificationApi,
  useAuthMutation,
  useAuthQuery,
} from '@sunrise-ui/api-client';
import { type CreateTokenTransactionInput } from '@sunrise-ui/api/gamification';
import { useAuthStore, useSnackbar } from '@sunrise-ui/primitives';
import { useQueryClient } from '@tanstack/react-query';

const { tokensKey } = QueryKeys.tokens;

export const useGetUserTokens = () => {
  const { currentUserId } = useAuthStore();

  return useAuthQuery({
    async queryFn() {
      assertParameterIsNotUndefinedOrNull(currentUserId, 'currentUserId');

      const response =
        await gamificationApi.getTokenCountTokensLedgersUsersUserIdCountGet({
          userId: currentUserId,
        });
      return response.data;
    },
    queryKey: [tokensKey, currentUserId],
    enabled: Boolean(currentUserId),
  });
};

export const useCreateTokenTransaction = () => {
  const { showSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useAuthMutation({
    async mutationFn({
      quantity,
    }: Pick<CreateTokenTransactionInput, 'quantity'>) {
      const { currentUserId } = useAuthStore.getState();

      assertParameterIsNotUndefinedOrNull(currentUserId, 'currentUserId');

      return gamificationApi.createTokenTransactionTokensTransactionsUsersPost({
        createTokenTransactionInput: {
          user_id: currentUserId,
          quantity,
          transaction_type: 'credit',
          reason: 'reward',
        },
      });
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: [tokensKey] });
    },
    async onError() {
      showSnackbar({
        text: 'Failed to gift tokens. Please try again.',
        type: 'error',
      });
    },
  });
};
